import x70s from "./data/x70s";
import x70_plus from "./data/x70-plus";
import x90_plus from "./data/x90-plus";
import dashing from "./data/dashing";
import x70_fl from "./data/x70-fl";
import t2 from "./data/t2";

export const baseUrl = "/assets/car";

const mainEl = document.getElementById("j360");
const resize = new Event("resize");

export function getMainElement() {
  return mainEl;
}

export function hideInterior() {
  mainEl.classList.remove("j360--interior");
}

export function showInterior() {
  mainEl.classList.add("j360--interior");
  window.dispatchEvent(resize);
}

export function getData() {
  const model = mainEl.dataset.model;

  switch (model) {
    case "dashing":
      return dashing;
    case "x70-plus":
      return x70_plus;
    case "x90-plus":
      return x90_plus;
    case "x70s":
      return x70s;
    case "x70-fl":
      return x70_fl;
    case "t2":
      return t2;
    default:
      return null;
  }
}
